import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { AdminService } from "../../../services/api/admin.service";
import { MpAdminActions } from "../../actions/mp-admin.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class VendorVerificationUpdateEffects {
	update = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.vendorVerification.update),
			switchMap((action) =>
				this.mpAdminService.updateVendorVerification(action.userId, action.statuses).pipe(
					map(() =>
						MpAdminActions.vendorVerification.updateSuccess({
							id: action.accountId,
							withActivation: action.withActivation
						})
					),
					catchError((error) =>
						of(MpAdminActions.vendorVerification.updateFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private mpAdminService: AdminService
	) {}
}
